module.exports = __webpack_public_path__ + "img/vvv-favicon.7da383da.png";